module.exports = __webpack_public_path__ + "img/KalsiyForte_Gray_1280x1010.709c9d37.jpg";